<template>
  <div class="e6Warp">
    <versionNav></versionNav>
    <div style='width:100%;height:106px'></div>
    <div class="inner">
      <div class="e8title">
        <img
          src="../assets/img/e8title.png"
          width="941"
          height="128"
        />
        <div class="wz">
          <p>活动范围<span>全区</span></p>
        </div>
      </div>
      <div class="e8table">
        <div class="e8lt1">
          <p>活动规则：</p>
          <p>
            1. 2018年4月23日维护后，所有在《全球使命3》单区单笔首次充值达到10元面值点券(1000点券)的玩家，次日都可获得一份豪华礼包，内含：<br>
            <span class="e8lt1-r">暴君-苍穹回响（橙）（1天）+传承核心x10+体质增强器III型以小搏大包x1+铁翅毒蜓时空箱（普通）</span>；
          </p>
          <p>
            2. 所有奖励将通过游戏内邮件的方式即时发送给玩家，为避免不必要的损失，请玩家于活动之前清理多余的邮件；
          </p>
          <p>
            3. 由于奖品发放数量较大，可能会出现最多1小时的延迟现象，请玩家耐心等待。如一小时后仍未收到奖励邮件，可通过客服邮件或<br>电话的方式联系我们，有当值客服为您解决问题。
          </p>
        </div>
        <div class="clearfloat"></div>
      </div>
      <div class="h50"></div>
    </div>
  </div> 
</template>
<script>
export default {
  name:"e6",
  created(){
    //this.getSelect()
  },
  methods:{
    getSeclect(){
    
    }
  }
}
</script>

<style scoped>
@import "./pagesCss/e6.css";
</style>


// WEBPACK FOOTER //
// src/pages/e6.vue